import { Element } from "@xmpp/xml"
import { jid } from "@xmpp/client"

type RouteGoogleLink = {
  googleLink: string | null
  from: ReturnType<typeof jid.parse>
  to: ReturnType<typeof jid.parse>
  id: string
  node: string
  sessionId: string
  status: string
}

export default class RouteGoogleLinkParser {
  static parse(stanza: Element): RouteGoogleLink | undefined {
    if (
      stanza.name !== "iq" ||
      !stanza.getAttr("from") ||
      !stanza.getAttr("to")
    )
      return

    const from = jid.parse(stanza.getAttr("from"))
    const to = jid.parse(stanza.getAttr("to"))
    const id = stanza.getAttr("id")

    const command = stanza.getChild(
      "command",
      "http://jabber.org/protocol/commands",
    )
    if (!command) return

    const node = command.getAttr("node")
    const sessionId = command.getAttr("sessionid")
    const status = command.getAttr("status")

    const json = command.getChild("json", "urn:xmpp:json:0")
    if (!json) return
    let parsedJson = null
    try {
      parsedJson = JSON.parse(json!.text())
    } catch (e) {
      console.log("Invalid JSON format in route google link")
    }

    return {
      googleLink: parsedJson?.url || null,
      from,
      to,
      id,
      node,
      sessionId,
      status,
    }
  }
}
